import { Plus, X } from "lucide-react";
import { LocationPicker } from "@/components/LocationPicker";
import { WaitSelect } from "@/components/booking/TripOptions";

export function StopsEditor({ stops, setStops, tiers }) {
  const update = (i, patch) => setStops(stops.map((s, j) => (j === i ? { ...s, ...patch } : s)));
  return (
    <div className="space-y-2" data-testid="stops-editor">
      {!stops.length && <p className="px-2 text-xs text-muted-foreground" data-testid="stops-empty-hint">Add at least one stop between pickup and destination.</p>}
      {stops.map((s, i) => (
        <div key={s.key} className="space-y-2 rounded-2xl border border-neon-violet/30 p-2" data-testid={`stop-row-${i}`}>
          <div className="flex items-center justify-end px-2 pt-1">
            <button type="button" onClick={() => setStops(stops.filter((_, j) => j !== i))} data-testid={`remove-stop-${i}`}
              className="grid h-7 w-7 place-items-center rounded-full text-muted-foreground hover:bg-muted hover:text-foreground">
              <X className="h-4 w-4" />
            </button>
          </div>
          <LocationPicker kind={`stop-${i}`} label={`Stop ${i + 1}`} value={s.place} allowGps onChange={(place) => update(i, { place })} />
          <label className="flex items-center justify-between gap-2 px-2 pb-1 text-xs text-muted-foreground">
            Wait at this stop
            <WaitSelect value={s.wait} onChange={(wait) => update(i, { wait })} tiers={tiers} testid={`stop-wait-${i}`} />
          </label>
        </div>
      ))}
      {stops.length < 5 && (
        <button type="button" onClick={() => setStops([...stops, { key: Date.now(), place: null, wait: 5 }])} data-testid="add-stop-button"
          className="flex items-center gap-1 rounded-full px-3 py-1 text-xs font-semibold text-neon-violet transition-colors hover:bg-neon-violet/10">
          <Plus className="h-3.5 w-3.5" /> Add stop
        </button>
      )}
    </div>
  );
}
